(function() {
    "use strict";
    var script = document.currentScript;
    var dataUrl = script && script.dataset.subsidyData;
    async function init() {
        var root = document.getElementById("shima-subsidy");
        var dataEl = document.getElementById("shima-subsidy-data");
        if (!root || root.dataset.ready || root.dataset.loading)
            return;
        root.dataset.loading = "true";
        var data;
        var loading = root.querySelector('[data-ss="loading"]');
        try {
            if (dataEl) {
                data = JSON.parse(dataEl.textContent);
            } else {
                if (!dataUrl) throw new Error("Missing data URL");
                var response = await fetch(dataUrl, { credentials: "omit" });
                if (!response.ok) throw new Error("Data request failed");
                data = await response.json();
            }
            if (!data || !Array.isArray(data.prefectures) || !data.prefectures.length || data.prefectures.some(function(p) { return !p.id || !p.name || !Array.isArray(p.rows) || p.rows.some(function(r) { return !r.city || !["あり", "あり（一時停止）", "なし"].includes(r.status); }); })) throw new Error("Invalid data");
        } catch (_) {
            if (loading) {
                loading.hidden = false;
                loading.textContent = "データを読み込めませんでした。ページを再読み込みしてください。";
                loading.setAttribute("role", "alert");
            }
            delete root.dataset.loading;
            return;
        }
        delete root.dataset.loading;
        var pref = root.querySelector('[data-ss="pref"]');
        var city = root.querySelector('[data-ss="city"]');
        var form = root.querySelector("form");
        var submit = root.querySelector('[data-ss="submit"]');
        var result = root.querySelector('[data-ss="result"]');
        var placeholder = root.querySelector('[data-ss="placeholder"]');
        var helper = root.querySelector('[data-ss="help"]');
        function node(tag, cls, text) {
            var el = document.createElement(tag);
            if (cls)
                el.className = cls;
            if (text !== undefined)
                el.textContent = text;
            return el
        }
        function empty(v) {
            return !v || /^[\s\-－—–]+$/.test(v)
        }
        function display(v) {
            return empty(v) ? "記載なし（自治体へ確認）" : v
        }
        function selectedPref() {
            return data.prefectures.find(function(p) {
                return p.id === pref.value
            })
        }
        function clearResult(message) {
            result.hidden = true;
            result.replaceChildren();
            placeholder.hidden = false;
            placeholder.textContent = message
        }
        function option(text, value) {
            var o = node("option", "", text);
            o.value = value;
            return o
        }
        var groups = {};
        data.prefectures.forEach(function(p) {
            if (!groups[p.region]) {
                groups[p.region] = document.createElement("optgroup");
                groups[p.region].label = p.region;
                pref.appendChild(groups[p.region])
            }
            groups[p.region].appendChild(option(p.name, p.id))
        });
        pref.disabled = false;
        if (loading) loading.hidden = true;
        root.dataset.ready = "true";
        pref.addEventListener("change", function() {
            city.replaceChildren(option("市区町村を選択してください", ""));
            var p = selectedPref();
            city.disabled = !p;
            submit.disabled = true;
            if (p)
                p.rows.forEach(function(r, i) {
                    city.appendChild(option(r.city, String(i)))
                });
            helper.textContent = p ? p.name + "の掲載自治体：" + p.rows.length + "件（助成なしの自治体も含みます）" : "まず都道府県を選択してください。";
            clearResult("お住まいの都道府県・市区町村を選択してください。")
        });
        city.addEventListener("change", function() {
            submit.disabled = !city.value;
            clearResult(city.value ? "「助成金情報を表示」を押してください。" : "市区町村を選択してください。")
        });
        form.addEventListener("submit", function(event) {
            event.preventDefault();
            var p = selectedPref();
            var r = p && city.value !== "" ? p.rows[Number(city.value)] : null;
            if (!r) return;
            result.replaceChildren();
            var head = node("div", "ss-result-head");
            head.appendChild(node("h4", "ss-result-title", p.name + " " + r.city + "の助成金"));
            var paused = r.status === "あり（一時停止）";
            var statusText = paused ? "助成制度あり（一時停止・調査時点）" : r.status === "なし" ? "助成制度なし（調査時点）" : "助成制度あり（調査時点）";
            head.appendChild(node("span", "ss-status" + (paused ? " ss-check" : r.status === "なし" ? " ss-muted" : ""), statusText));
            result.appendChild(head);
            if (r.status !== "なし") {
                var cards = node("div", "ss-amounts");
                var pairs = [["購入価格に対する助成率", r.rate], [r.amountCondition === "一律" ? "助成金額（一律）" : r.amountCondition === "上限" ? "助成金額（上限）" : "助成金額", r.amount], ["申請の方法", r.application], ["販売店指定", r.shop]];
                pairs.forEach(function(item, i) {
                    var card = node("div", "ss-amount-card");
                    card.appendChild(node("p", "ss-card-label", item[0]));
                    card.appendChild(node("p", "ss-card-value" + (i > 1 ? " ss-text-value" : ""), empty(item[1]) ? "記載なし" : item[1]));
                    cards.appendChild(card);
                });
                result.appendChild(cards);
            }
            result.appendChild(node("p", "ss-date", "更新日：" + (r.updatedAt || "未確認")));
            if (r.remarks) result.appendChild(node("p", "ss-message" + (paused ? " ss-caution" : ""), "備考：" + r.remarks));
            placeholder.hidden = true;
            result.hidden = false
        })
    }
    document.addEventListener("shopify:section:load", init);
    if (document.readyState === "loading")
        document.addEventListener("DOMContentLoaded", init);
    else
        init()
}
)();
